import { render } from "./PackageDiscountsListModal.vue?vue&type=template&id=53cedd3d&scoped=true"
import script from "./PackageDiscountsListModal.vue?vue&type=script&lang=js"
export * from "./PackageDiscountsListModal.vue?vue&type=script&lang=js"

import "./PackageDiscountsListModal.vue?vue&type=style&index=0&id=53cedd3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cedd3d"]])

export default __exports__